import React, { HTMLAttributes } from "react";
import { Link } from "react-router-dom";

interface IHeader {
  nolink?: boolean;
}

type THeaderProps = IHeader & HTMLAttributes<HTMLDivElement>;

const Header: React.FC<THeaderProps> = (props) => {
  const { nolink, ...otherProps } = props;

  return (
    <div {...otherProps}>
      <div className="flex justify-between items-center m-6 laptop:m-10 z-10">
        {/* left top logo */}

        {!nolink ? (
          <Link to="/">
            <img
              className="w-[8rem] h-[3rem]"
              src={require("../../../assets/images/asgard-ev-logo.png")}
              alt="asgard-ev-logo"
            />
          </Link>
        ) : (
          <img
            className="w-[8rem] h-[3rem]"
            src={require("../../../assets/images/asgard-ev-logo.png")}
            alt="asgard-ev-logo"
          />
        )}

        {/* right top logo */}
        <img
          className="w-[120px] h-[32px]"
          src={require("../../../assets/images/asgard-ev-logo2.png")}
          alt="asgard-ev-logo2"
        />
      </div>
    </div>
  );
};

export default Header;
